import template from './request-success.html';
import controller from './request-success.controller';
import './request-success.scss';

let RequestSuccessComponent = {
  bindings: {
    email: '<'
  },
  template,
  controller
};

export default RequestSuccessComponent;



// WEBPACK FOOTER //
// ./src/app/pages/request-success/request-success.component.js